export enum CommentsActions {
    SET_COMMENTS = 'SET_COMMENTS',
    ADD_COMMENTS = 'ADD_COMMENTS',
    UPDATE_COMMENTS = 'UPDATE_COMMENTS',
    DELETE_COMMENTS = 'DELETE_COMMENTS',
    CLEAR_COMMENTS = 'CLEAR_COMMENTS',
}
